import React from 'react';
import ReactDOM from 'react-dom/client';
import './posthog';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { trackWebVitals } from './utils/analytics';
import { BrowserRouter } from 'react-router-dom';
import { DevModeProvider } from './context/DevModeContext';

const theme = createTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <DevModeProvider>
          <App />
        </DevModeProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals(trackWebVitals);
